// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"W9-z"};